import React, { useEffect, useState } from "react";
import { CreditCard, Pencil, Trash2, UserPlus, Users, Building2, FileDown, LogOut, ScrollText } from "lucide-react";
import api from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";

const ICONS = {
  "card.create": CreditCard, "card.update": Pencil, "card.delete": Trash2,
  "seat.allocate": UserPlus, "seat.self_register": Users,
  "account.create": Building2, "account.update": Pencil, "account.delete": Trash2,
  "leads.export": FileDown,
};

function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <DashboardLayout title="Audit Log">
      {loading ? <p className="text-[#8B9BB4]">Loading…</p> :
        logs.length === 0 ? (
          <div className="iw-card p-12 text-center">
            <ScrollText className="text-[#D4AF37] mx-auto mb-3" size={32} />
            <h3 className="font-display text-2xl font-bold">No activity yet</h3>
            <p className="text-[#8B9BB4] mt-2">Every card edit, seat change, account update and lead export will be logged here.</p>
          </div>
        ) : (
          <div className="iw-card p-6 fade-up">
            <p className="overline mb-6">Activity Timeline</p>
            <div className="relative pl-6">
              <div className="absolute left-[9px] top-1 bottom-1 w-px bg-[#ffffff1a]" />
              {logs.map((l) => {
                const Icon = ICONS[l.action] || ScrollText;
                return (
                  <div key={l.id} className="relative pb-6 last:pb-0" data-testid={`audit-${l.id}`}>
                    <div className="absolute -left-6 h-5 w-5 rounded-full bg-[#142B5A] border border-[#D4AF37]/40 flex items-center justify-center">
                      <Icon size={11} className="text-[#D4AF37]" strokeWidth={2} />
                    </div>
                    <div className="flex items-center justify-between gap-4">
                      <p className="text-sm text-[#F6F1E4]">{l.detail || l.action}</p>
                      <span className="text-xs text-[#8B9BB4] shrink-0">{timeAgo(l.created_at)}</span>
                    </div>
                    <span className="overline text-[10px]">{l.action.replace(".", " · ")}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
    </DashboardLayout>
  );
}
